import { AspectRatio } from 'services/clip.service';
import { useAppSelector } from 'store/store-hooks';
import { selectClipData } from 'components/app/editor/_mediator/editor.slice';
import { usePanZoomContext } from './_pan-zoom.provider';

export const usePanZoomAr = () => {
  const clipData = useAppSelector(selectClipData);
  const { frameEl, viewerEl, panZoomRotate, ARViewerSize, setARViewerSize, setPanZoomRotate, setZoomRect } =
    usePanZoomContext();

  return (aspectRatio: AspectRatio) => {
    if (!clipData) return;

    const frameRect = frameEl.current!.getBoundingClientRect();
    const viewerElRect = viewerEl.current!.getBoundingClientRect();
    const zoom = panZoomRotate.zoom;

    setARViewerSize(aspectRatio, clipData.config.rotate);

    const width = ARViewerSize.current.width * zoom;
    const height = ARViewerSize.current.height * zoom;
    const diffW = frameRect.width - width;
    const diffH = frameRect.height - height;
    let left = panZoomRotate.left + diffW / 2;
    let bottom = panZoomRotate.bottom + diffH / 2;

    if (left < 0) left = 0;
    else if (left + width > viewerElRect.width) left = viewerElRect.width - width;
    if (bottom < 0) bottom = 0;
    else if (bottom + height > viewerElRect.height) bottom = viewerElRect.height - height;

    setZoomRect({ left, bottom, zoom });
    setPanZoomRotate({ left, bottom, aspectRatio });
  };
};
